import React, { useEffect, useRef } from 'react';
import { Container } from './styles';

// import smileImage from '~/assets/tv/november-2025/4.mp4';
import smileImage from '~/assets/tv/october-2025/TV4.mp4'; // TODO: placeholder, trocar pelo vídeo de novembro

interface IChangeYourSmile4Props {
  show: boolean;
  startAnim: boolean;
}

const ChangeYourSmile4: React.FC<IChangeYourSmile4Props> = ({
  show,
  startAnim,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (show && videoRef?.current) {
      videoRef.current.currentTime = 0; // Reseta o vídeo para o início
      videoRef.current?.play?.(); // Garante que o vídeo comece a tocar
    }
  }, [show]);

  return (
    <Container show={show} startAnim={startAnim}>
      <video
        controls={false}
        playsInline
        autoPlay
        muted
        className="w-100 mb-5"
        ref={videoRef}
      >
        <source src={smileImage} type="video/mp4" />
      </video>
    </Container>
  );
};

export default ChangeYourSmile4;
